import { deepMix } from '@antv/util';
import { geometry } from './base';
/**
 * polygon 的配置处理
 * @param params
 */
export function polygon(params) {
    var options = params.options;
    var polygon = options.polygon, seriesField = options.seriesField;
    return polygon
        ? geometry(deepMix({}, params, {
            options: {
                colorField: seriesField,
                type: 'polygon',
                mapping: polygon,
            },
        }))
        : params;
}
//# sourceMappingURL=polygon.js.map